<template>
    <div class="page_content_top_line div_btn">
        <div v-if="btnFlag" class="button">
            <el-button type="primary" size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue, buttonKey) in buttonList" :key="buttonKey">
                {{ buttonValue.jurName }}
            </el-button>
            <slot name="buttonList"></slot>
        </div>
        <slot v-else name="button"></slot>
        <ul class="ul_btn">
            <slot name="text"></slot>
            <li v-if=" (showRefresh || buttonFlag)&&btnFlag">
                <el-tooltip class="item" effect="dark" content="刷新" placement="top">
                    <i class="el-icon-refresh icons" @click="getPageInfo"></i>
                </el-tooltip>
            </li>
            <slot name="li"></slot>
            <li v-if="buttonFlag">
                <el-tooltip class="item" effect="dark" content="设置" placement="top">
                    <i class="el-icon-setting icons" @click="openFormDesign"></i>
                </el-tooltip>
            </li>
            <li>
                <el-tooltip class="item" effect="dark" content="帮助" placement="top">
                    <i class="el-icon-question icons" @click="openWord"></i>
                </el-tooltip>
            </li>
        </ul>
        <el-dialog title="操作文档" :visible.sync="dialogVisible" top="1vh" width="90%" :modal-append-to-body="true" :append-to-body="true">
            <div ref="czwd" v-html="helpValue" class="czwd"></div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "vButton",
    props: {
        //动态按钮列表
        buttonList: {
            type: Array,
            default: () => {
                return []
            }
        },
        //控制刷新的显示和隐藏 true:显示 false:隐藏（和buttonFlag、btnFlag组合使用）
        showRefresh: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        //控制自定义设置的显示和隐藏 true:显示 false:隐藏
        buttonFlag: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        //控制动态按钮的显示和隐藏 true:显示 false:隐藏
        btnFlag: {
            type: Boolean,
            default: () => {
                return true
            }
        },
    },
    data() {
        return {
            jurId: "",
            dialogVisible: false,
            helpValue: "",
        }
    },
    methods: {
        actionSet(actionData) {
            this.$emit('actionSet', actionData)
        },
        getPageInfo() {
            this.$emit('getPageInfo')
        },
        openFormDesign() {
            this.$emit('openFormDesign')
        },
        openWord() {
            this.jurId = parent.getMenuInfo(this.$route.path).jurId;
            this.getDocument()
        },
        async getDocument() {
            let params = {
                ids: [this.jurId]
            }
            var responseData = await this.$http.getDocumentData(params)
            if (responseData.status == 200) {
                if (responseData.result != null) {
                    this.dialogVisible = true
                    this.helpValue = responseData.result.documentData.split("<img").join("<img width='100%' ")
                } else {
                    this.$message.warning("暂未维护帮助文档")
                    this.helpValue = ''
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
    },
}
</script>

<style scoped>
.czwd {
    overflow: auto;
}

.div_btn {
    justify-content: space-between;
}

ul {
    list-style: none;
}

.div_btn .ul_btn li:hover {
    color: #409eff;
}

.div_btn .ul_btn {
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.div_btn .ul_btn li {
    padding: 5px 3px;
}

.icons {
    font-size: 18px;
    cursor: pointer;
}
.button{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
</style>